export default function searchView() {
    return "\n  <div class=\"search-bar\">\n    <input type=\"text\" id=\"search-view-input\"/>\n    <a class=\"navigation-button\" id=\"search-view-button\">\n      <i class=\"fas fa-search\"></i>\n    </a>\n  </div>\n  ";
}
